<div class="no-access-page">
  <div class="no-access-page-body">
    <img src="../../assets/cloud.png"/>
    <p class="something-is-wrong">Something Is Wrong With Your Access</p>
    <p class="if-you-have-question">Looks like you don't have access to any member. Please contact CPSC support team:
  </div>
</div>
